export default "__VITE_ASSET__DIfT14bS__"